"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatVariableValue = void 0;
var timeFormat = function (value) {
    var formattedValue = (value / 1000).toFixed(1);
    if (formattedValue === '0.0') {
        formattedValue = '0';
    }
    return formattedValue + 's';
};
var noopFormat = function () { return ''; };
// TODO
var variableFormatters = {
    // character
    health: String,
    actionTime: timeFormat,
    position: noopFormat,
    orientation: String,
    // spell
    duration: timeFormat,
    rangeArea: String,
    actionArea: String,
    lineOfSight: noopFormat,
    attack: String
};
var formatVariableValue = function (variableName, value, _a) {
    var _b = _a === void 0 ? {} : _a, relative = _b.relative;
    var valuePrefix = relative && typeof value === 'number' && value >= 0
        ? '+'
        : '';
    var formatter = variableFormatters[variableName];
    return valuePrefix + formatter(value);
};
exports.formatVariableValue = formatVariableValue;
